import React, { useEffect, useState } from "react";

import "./style.scss";
import closeImg from "../../images/close-icon.png";

interface Props {
  visible: boolean;
  unShadom?: boolean;
  style?: React.CSSProperties;
  layerStyle?: React.CSSProperties;
  children?: React.ReactNode;
  onCancel: () => void;
  keepAlive?: boolean;
  closeable?: boolean;
  closeText: string;
  isDialog?: boolean;
  onClick?: () => void;
}

const modalShowIndex = 102;

const Modal: React.FC<Props> = (props: Props) => {
  const {
    visible,
    unShadom = false,
    style,
    layerStyle,
    onCancel = () => {},
    children,
    keepAlive = false,
    closeable = true,
    closeText = true,
    isDialog = false,
    onClick = () => {},
  } = props;
  const [show, setShow] = useState(false);
  const [zIndex, setZIndex] = useState(0);

  useEffect(() => {
    setTimeout(() => {
      setShow(visible);
    });
  }, [visible]);

  useEffect(() => {
    if (show) {
      const allModalRoot = document.querySelectorAll(".modal-root");
      const modalNum = allModalRoot.length;
      const num = modalNum > 1 ? 0 : 1;
      setZIndex(modalShowIndex + modalNum - num);
    }
  }, [show]);

  return keepAlive || visible ? (
    <div className="modal-root" onClick={onClick}>
      <div
        className={`${isDialog ? "modal--dialog" : "modal"} ${
          show ? "modal--show" : ""
        } ${unShadom ? "modal--bottom" : ""}`}
        style={show ? { zIndex, ...style } : style}
      >
        {closeable && closeText && !isDialog && (
          <span
            className="close-text"
            onClick={() => {
              onCancel();
            }}
          >
            关闭
          </span>
        )}
        {closeable && (
          <img
            className="close-icon"
            src={closeImg}
            alt="close"
            onClick={() => {
              onCancel();
            }}
          />
        )}
        {children}
      </div>
      <div
        style={show ? { zIndex: zIndex - 1, ...layerStyle } : layerStyle}
        className={`modal-layer ${
          show && !unShadom ? "modal-layer--show" : ""
        }`}
        onClick={() => {
          onCancel();
        }}
      />
    </div>
  ) : null;
};

export default Modal;
